import React, { useEffect } from 'react'
import { Parallax } from 'react-parallax'
import './css/secondpara.css'

const ThirdParalax = () => {
  useEffect(() => {
    const section = document.querySelector('#services')
    const lists = document.querySelectorAll('.services-li')
    const cards = document.querySelectorAll('.cards')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lists.forEach(i => {
            i.classList.add('animated-services')
          })
          cards.forEach(i => {
            i.classList.add('animated-cards')
          })
        }
      })
    })

    observer.observe(section)
  }, [])

  const services = [
    {
      id: 1,
      title: 'Web Development',
      desc: '  I provide web development services to bring your website design to life, creating a seamless user experience that engages your audience and achieves your online goals. I specialize in building responsive websites that work seamlessly across all devices, ensuring that your website is accessible to everyone. Using the latest technologies and frameworks, I can create dynamic and interactive websites that meet your unique needs and preferences. I also prioritize website security, ensuring that your website is protected against cyber threats and data breaches. Whether you need a simple brochure website, a complex e-commerce platform, or a custom web application, I can help you build a website that delivers the results youre looking for.'
    },
    {
      id: 2,
      title: 'Web Design',
      desc: ' I provide web design services to create beautiful, functional, and user-friendly websites that help your business achieve its online goals. I take a customer-centric approach, working closely with you to understand your unique needs, preferences, and goals. From there, I create a custom design that reflects your brand identity, conveys your message, and engages your audience. My designs are optimized for all devices, ensuring that your website is accessible to everyone, and I prioritize fast loading times and easy navigation. Whether you need a simple brochure website or a complex e-commerce platform, I can help you create a website that stands out from the crowd and delivers results.'
    },
    {
      id: 3,
      title: 'Code Debugging',
      desc: ' I provide expert code debugging services to help you identify and fix any issues with your software. Whether youre dealing with a crash, error, or malfunction, I can help you quickly diagnose and solve the problem. Using advanced debugging tools and techniques, I can efficiently troubleshoot your code, pinpoint the root cause of the issue, and implement a solution that ensures your software runs smoothly. With my code debugging services, you can save time and money by avoiding costly downtime, improving your software performance, and minimizing the risk of future errors.'
    },
    {
      id: 4,
      title: 'College Projects',
      desc: 'I provide college project services to help you with your academic assignments. As a knowledgeable and experienced professional, I can assist you with any aspect of your college project, from research and planning to execution and presentation. Whether you need help with an essay, research paper, or presentation, I can provide guidance and support to ensure that you meet your academic goals. With my college project services, you can receive customized and high-quality assistance that helps you achieve academic success. Additionally, I can provide feedback and suggestions to help you improve your skills and become a better student.'
    }
  ]
  let index = 1
  return (
    <Parallax
      className='paralax bg-third'
      bgImage={'white'}
      style={{ background: 'white' }}
      strength={400}
    >
      <div id='services' className='secondpara'>
        <div className='services-li title'>
          <p>WHAT I DO</p>
          <br />
          <div style={{ color: 'black' }}>
            EVERYTHING YOU NEED TO START AND LAUNCH
          </div>
          <hr />
        </div>
        <div className='services-li description th-desc'>
          {services.map(i => {
            return (
              <div key={i.id} className='services cards'>
                <div className='icon'>
                  <img src={`/services/img${index++}.png`} alt='' />
                </div>
                <div className='label'>
                  <div className='tit'>{i.title}</div>
                  <div style={{ fontFamily: 'Gruppo' }} className='desc'>
                    {i.desc}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </Parallax>
  )
}

export default ThirdParalax
